/**
 * Promise-based delay for pausing async functions for arbitrary periods of time.
 * @param {number} ms Time to wait (in milliseconds)
 */
export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
